<template>
  <BaseIndex
    ref="baseIndex"
    :modelNameSingular="modelNameSingular"
    :modelNamePlural="modelNamePlural"
    :pageLoading="pageLoading"
    :loading="loading"
    :table-headers="tableHeaders"
    :table-items="purchases"
    :maskFields="maskFields"
    :infoHeaders="infoHeaders"
    :itemClass="itemClasses"
    @options-change="optionsChange"
    :serverItemsLength="totalItems"
    :loadOptions="options"
    :enableCustomFilters="true"
    :containTopToolbar="false"
    :typeOperators="typeOperators"
    :serverFields="serverFields"
    @filter-confirm-action="applyFilters"
  >

    <!-- <template slot="link1" v-if="item.nfes.length > 0" slot-scope="{ item }">
      <v-tooltip top>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
            text
            icon
            link
            v-on="{ ...tooltip }"
            :to= "'/app/outbound_nfes?saleId=' + item.id"
          >
            <v-badge
              :content="item.nfes.length"
              :value="item.nfes.length"
              color="green"
              overlap
              offset-x="8"
              offset-y="8"
            >
              <v-icon>mdi-file-certificate</v-icon>
            </v-badge>
          </v-btn>
        </template>
        <span>Visualizar NF-e{{item.nfes.length > 1 ? 's' : ''}}</span>
      </v-tooltip>
    </template> -->

    <template slot="new" v-if="$can('create', $router.currentRoute.name)">
      <New
        @entry-created="entryCreated"
        @entry-canceled="loadServerEntries()"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <!-- <template slot="new" v-if="$can('create', $router.currentRoute.name)">
      <Import
        @entry-created="entryCreated"
        :modelNameSingular="modelImport"
      />
    </template> -->

    <template slot="filterText1">
        <v-card style="margin: 10px;">
          <v-text-field
            style="padding: 16px 16px;"
            v-model="itemName"
            label="Item"
            >
          </v-text-field>
        </v-card>
    </template>

    <template slot="show" slot-scope="{ item }" v-if="$can('read', $router.currentRoute.name)">
      <Edit
        :entry="item"
        :readOnly="true"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="edit" slot-scope="{ item }" v-if="$can('update', $router.currentRoute.name)">
      <Edit
        :entry="item"
        @entry-updated="entryUpdated"
        v-if="item.statusKey == 'opened'"
        @entry-canceled="loadServerEntries()"
        :modelNameSingular="modelNameSingular"
        :isEdit="true"
      />
      
    </template>

    <template slot="delete" slot-scope="{ item }" v-if="$can('delete', $router.currentRoute.name)">
      <Delete
        :entry="item"
        @entry-destroyed="entryDeleted"
        :readOnly="item.statusKey != 'opened'"
        @entry-canceled="loadServerEntries()"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template v-if="$can('update', $router.currentRoute.name) && item.statusKey == 'opened'" slot="action1" slot-scope="{ item }">
      <PurchaseBilling 
        :entry="item"
        @entry-updated="entryBilled"
        @entry-canceled="loadServerEntries()"
        modelNameSingular="Faturamento de Compra"
      />
    </template>

    <template v-if="$can('update', $router.currentRoute.name) && item.statusKey != 'opened'" slot="action2" slot-scope="{ item }">
      <CancelPurchaseBilling 
        :entry="item"
        @entry-destroyed="entryBillingCanceled"
        @entry-canceled="loadServerEntries()"
        modelNameSingular="Cancelamento de Faturamento de Compra"
      />
    </template>

    <template slot="tableFooter">
      <tr class="d-none d-md-table-row">
        <td colspan="3" class="text-right"><strong class= "mx-3">Total: </strong></td>
        <td colspan="2" class="text-left"><strong>{{ this.totalValue | formatCurrency }}</strong></td>
        <td colspan="1" class="text-left"><strong>{{ this.totalPendent | formatCurrency }}</strong></td>
      </tr>
      <!-- for mobile only -->
      <tr class="d-table-row d-md-none v-data-table__mobile-table-row">
        <td class="v-data-table__mobile-row">
          <div class="v-data-table__mobile-row__header">Total: </div>
          <div class="v-data-table__mobile-row__cell"><strong>{{ this.totalValue | formatCurrency }}</strong></div>
          <div class="v-data-table__mobile-row__cell"><strong>{{ this.totalPendent | formatCurrency }}</strong></div>
        </td>
      </tr>
    </template>

  </BaseIndex>
</template>

<script>
import gql from 'graphql-tag';
import BaseIndex from "@shared_components/base_index.vue";
import New from "./new.vue";
import Edit from "./edit.vue";
import Delete from "./delete.vue";
import PurchaseBilling from "./purchaseBilling.vue";
import CancelPurchaseBilling from "./cancelBilling.vue";
import Import from "./import.vue";

export default {
  data() {
    return {
      purchases: [],
      loading: true,
      pageLoading: false,
      totalItems: 0,
      totalValue: 0,
      totalPaid: 0,
      itemName: null,
      totalPendent: 0,
      tableHeaders: [
        { text: "Código", align: "left", sortable: true, value: "code"},
        // { text: "Série", align: "left", sortable: true, value: "code"},
        { text: "Nº da NF-e", align: "left", sortable: true, value: "number"},
        { text: "Faturamento", align: "left", sortable: true, value: "billDate" },
        { text: "Fornecedor", align: "left", sortable: true, value: "supplier.name" },
        { text: "Valor", align: "left", sortable: false, value: "totalPrice"},
        // { text: "Pago", align: "left", sortable: false, value: "totalPaidAmount"},
        { text: "Pendente", align: "left", sortable: false, value: "unpaidAmount"},
        { text: "Status", align: "left", sortable: true, value: "purchaseStatus" },
        // { text: "Entrega", align: "left", sortable: true, value: "deliveryDate" },
        { text: "Ações", align: "left", sortable: false, value: "action" }
      ],
      maskFields: [
        { field: 'billDate', mask: 'date' }, 
        { field: 'deliveryDate', mask: 'date' },
        { field: 'totalPrice', mask: 'currency' }, 
        { field: 'totalPaidAmount', mask: 'currency' }, 
        { field: 'unpaidAmount', mask: 'currency' }, 
        { field: 'purchaseStatus', mask: 'status_color', colorField: 'statusColor' }, 
      ],
      infoHeaders: [
        { field: 'totalPrice', info: 'Valor da compra a pagar (capital)' },
        { field: 'totalPaidAmount', info: 'Valor já pago da compra incluindo juros, multas e descontos' },
        { field: 'unpaidAmount', info: 'Valor restante a ser pago (capital)' },
      ],
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ["code"],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: true
      },
      filters: [],
      typeOperators: [],
      serverFields: [],
    };
  },
  props: {
    modelNameSingular: {
      type: String,
      default: "Compra"
    },
    modelNamePlural: {
      type: String,
      default: "Compras"
    },
    newCreateButtonLabel: {
      type: String,
      default: function() {
        return "Importar " + this.modelNameSingular
      }
    },
    modelImport:{
      type: String,
      default: function(){
        return "Importar compra"
      }
    }
  },
  components: {
    BaseIndex: BaseIndex,
    New: New,
    Edit: Edit,
    Delete: Delete,
    PurchaseBilling: PurchaseBilling,
    CancelPurchaseBilling: CancelPurchaseBilling,
    Import: Import,
  },
  created() {
    // this.loadServerEntries();
    // let data = this.$root.$data
    // this.getCurrentUser(user => {
    //   console.log("feito", user);
    // });
    // setTimeout(function(){
    //   console.log("Index sale", data.localUser);
    // }, 1000)
  },
  mounted() { 
    
  },
  watch: {
    "itemName": function(newSearch) {
      if (this.itemName && this.itemName.length > 0) {
        if (newSearch.length >= 3) {
          if(this.timer){
            clearTimeout(this.timer);
          }
          this.timer = setTimeout( ()=> {
            // console.log("newSearch", newSearch); 
            this.loadServerEntries();
          }, 2000);
        }
      }else{
        if(this.timer){
          clearTimeout(this.timer);
        }
        this.loadServerEntries();
      }
    },
  },
  methods: {
    applyFilters: function(filtersList) {
      this.filters = filtersList;
      this.options.page = 1;
      this.loadServerEntries();
    },
    loadServerEntries: function() {
      // console.log("FILTERS enviados", this.filters);
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_ALL_PURCHASES,
          variables: {
            input: {
              limit: this.options.itemsPerPage,
              offset: (this.options.page - 1) * this.options.itemsPerPage,
              sortBy: this.options.sortBy,
              sortDesc: this.options.sortDesc,
              fields: this.tableHeaders.map(val => val.value),
              filters: this.filters,
              customFilters: {products: this.itemName},
            }
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          // console.log("response", response);
          this.purchases = response.data.accountContext.purchasesIndex.purchaseViewIndexFilters;
          this.totalValue = response.data.accountContext.purchasesIndex.totalValue;
          this.totalPaid = response.data.accountContext.purchasesIndex.totalPaid;
          this.totalPendent = response.data.accountContext.purchasesIndex.totalPendent;

          this.totalItems = response.data.accountContext.purchasesIndex.count;
          this.typeOperators = response.data.accountContext.purchasesIndex.typeOperators;
          this.serverFields = response.data.accountContext.purchasesIndex.serverFields;
          // console.log("All purchases", this.purchases, this.totalItems);
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    entryUpdated: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationUpdateMessage();
    },
    entryBilled: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationMessage("Compra faturada com sucesso!");
    },
    entryCreated: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationCreateMessage();
    },
    entryDeleted: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationDeleteMessage();
    },
    entryBillingCanceled: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationMessage("Faturamento da compra cancelado com sucesso!");
    },
    optionsChange: function(opts) {
      // console.log("alterou as options");
      this.options = opts;
      this.loadServerEntries();
    },
    itemClasses: function(item) {
      if (item.statusKey == "opened") {
        return "opened_item";
      } else if (item.unpaidAmount > 0) {
        return "pending_item";
      }
    },
  }
};

const LOAD_ALL_PURCHASES = gql `
  query($input: IndexInputObject!) {
    accountContext {
      purchasesIndex(input: $input) {
        count
        totalValue
        totalPaid
        totalPendent
        purchaseViewIndexFilters {
          id
          code
          status
          statusKey
          purchaseStatus
          series
          cfopId
          number
          statusColor
          estimatedDeliveryDate
          orderValidity
          supplierId
          supplier {
            id
            name
          }
          billDate
          totalPrice
          paidAmount
          totalPaidAmount
          unpaidAmount
          canBeDeleted
          undeletabilityReasons
        }
        typeOperators
        serverFields
      }
    }
  }
`;

</script>

<style scoped>
  ::v-deep .pending_item {
    color: red;
  }

  ::v-deep .opened_item {
    color: rgb(134, 134, 134);
    font-style: italic;
  }
</style>
